import React from 'react'
import PopOnMe from './elements/poponme';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { IAction } from '../resources/interfaces';

type Props = {
    actions: Array<IAction>;
    onClick?: any;
    onClickOutside?: any;
    tippyWrapperStyles?: any;
    removeButtonHoverEffect?: boolean;
    popOptionClasses?: string;
    text?: string;
    children?: React.ReactNode;
    isTable?: boolean;
    showDropdown?: boolean;
    classNames?: string;
    isSubmitting?: boolean;
    placement?: "top-start" | "top-end" | "bottom-start" | "bottom-end" | "right-start" | "right-end" | "left-start" | "left-end";
}

const ActionsPopOnMe = ({ actions, onClick, onClickOutside, tippyWrapperStyles, removeButtonHoverEffect, popOptionClasses, text, children, isTable, showDropdown = false, classNames, isSubmitting, placement }: Props) => {
    return (
        <PopOnMe actions={actions} popOptionClasses={popOptionClasses} onClick={onClick} onClickOutside={onClickOutside} tippyWrapperStyles={tippyWrapperStyles} removeButtonHoverEffect={removeButtonHoverEffect} placement={placement}>
            {children ?
                <div className="cursor-pointer">{children}</div> : (
                    <button className={`flex justify-between items-center outline-none  text-[#F57F17] border-[2px] border-primary-main px-4 py-1 w-fit rounded-full ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''} ${classNames}`} disabled={isSubmitting} >
                        <span>{text || 'Actions'}</span>
                        {showDropdown && <ChevronDownIcon className="w-4 ml-2" />}
                    </button>
                )}

        </PopOnMe>
    )
}

export default ActionsPopOnMe